import React, { useState, useEffect } from 'react'

// Material UI
import AppBar from '@material-ui/core/AppBar'
import CardMedia from '@material-ui/core/CardMedia'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

// Components
import MenuCategory from '../MenuCategory/MenuCategory'
import MenuTabPanel from './MenuTabPanel'
import Header from '../Header/Header'

// Style
import { makeStyles } from '@material-ui/core/styles'

// Loader
import SyncLoader from "react-spinners/SyncLoader"

// Redux
import { connect } from 'react-redux'

// CSS
import './Menu.css'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  media: {
    height: '100%',
    maxHeight: 300,
    paddingTop: 5,
    paddingBottom: 5,
  },
  loading: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const Menu = ({ storeData, menuData, clientData }) => {

  const classes = useStyles()
  const [value, setValue] = useState(0)
  const [sortedCategories, setSortedCategories] = useState([])

  // Loader
  const loading = useState(true)

  const { store } = storeData
  const { menu } = menuData
  const { client } = clientData

  const categories = menu.Categories

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  useEffect(() => {
    setSortedCategories(categories.filter(category => category["Online_Disable"] === false && category[client.diningView] === true && category["Parent_UID"] === 0))
    // eslint-disable-next-line
  }, [])

  if (menu.length === 0) {
    return (<div className={classes.loading}>
      <SyncLoader
        size={40}
        color={"#123abc"}
        loading={loading}
      />
    </div>)
  }

  return (
    <>
      <Header action={true} title={"Menu"} languageIcon={true} phoneIcon={true} cartIcon={true} />
      <CardMedia
        component="img"
        alt="Company Logo"
        className={classes.media}
        image={store.CLIENT_IMG}
      />
      <div className={classes.root}>
        <AppBar position="sticky" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="on"
          >
            {sortedCategories.map((category) =>
              <Tab
                key={category.UID}
                style={{ fontSize: "large", fontWeight: "bold" }}
                label={category.Name} />
            )
            }
          </Tabs>
        </AppBar>

        {sortedCategories.map((category, index) => {
          return (<MenuTabPanel
            key={category.UID}
            value={value}
            index={index}
          >
            <MenuCategory
              data={category}
            />
          </MenuTabPanel>)
        })}

      </div>
    </>
  );
}

const mapStateToProps = state => {
  return {
    storeData: state.storeData,
    menuData: state.menuData,
    clientData: state.clientData
  }
}

export default connect(mapStateToProps)(Menu)